import React from 'react'
import VisuallyHidden from '@reach/visually-hidden'
import classNames from 'classnames'

import styles from './styles.module.scss'

const Spinner = ({
  size,
  thickness,
  className,
  children,
  speed,
  delay = 0.3,
  isCentered = false,
  isCenteredTop = false,
  isInline,
  isStacked,
  style,
}) => (
  <div
    className={classNames(className, {
      [styles.isCentered]: isCentered || isCenteredTop,
      [styles.isInline]: isInline,
      [styles.isCenteredTop]: isCenteredTop,
    })}
  >
    <div
      className={classNames(styles.spinnerContainer, {
        [styles.isStacked]: isStacked,
      })}
      style={{
        // Fade in slower than the delay so spinner is actually spinning
        // when we fade in
        animationDelay: delay ? `${delay + 0.1}s` : undefined,
      }}
    >
      <div
        className={styles.spinnerWrapper}
        style={{ fontSize: size ? `${size}em` : undefined }}
      >
        <div
          className={classNames(styles.spinner)}
          style={{
            borderWidth: thickness ? `${thickness}px` : undefined,
            animationDuration: speed ? `${speed}s` : undefined,
            animationDelay: delay ? `${delay}s` : undefined,
            ...style,
          }}
        />
      </div>
      <div className={classNames({ [styles.loadingText]: !!children })}>
        {!children && <VisuallyHidden>Loading…</VisuallyHidden>}
        {children}
      </div>
    </div>
  </div>
)

export default Spinner
